<template>
  <div>
    <img
      class="inline-block m-4"
      src="@/assets/images/ai-no-result.svg"
    >
    <div v-if="!customText.length">
      <p>{{ $i18nPresenter.t("Our AI encountered a minor hiccup.") }}</p>
      <p>{{ $i18nPresenter.t("Let's give it another shot...") }}</p>
    </div>
    <div v-else>
      <p v-for="(text, textIndex) in customText" :key="textIndex">
        {{ $i18nPresenter.t(text) }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIStumped',
  props: {
    customText: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
